<template>
  <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <h5 class="mb-0">
        Plano Atual
      </h5>
      <b-badge variant="light-primary">
        {{ userData.currentPlan }}
      </b-badge>
      <small class="text-muted w-100">{{ userData.dataPlan }}</small>
    </b-card-header>

    <b-card-body>
      <ul class="list-unstyled my-1">
        <li>
          <span class="align-middle">Todos os recursos</span>
        </li>
        <li class="my-25">
          <span
            v-if="userData.currentPlan === 'PRO Booster'"
            class="align-middle"
          > Plays consumidos: {{ userData.qtde_play }} / 40.000</span>
          <span
            v-if="userData.currentPlan === 'VSL Booster'"
            class="align-middle"
          >Plays consumidos: {{ userData.qtde_play }} / 15.000</span>
        </li>
        <li>
          <span class="align-middle">R$ 0,02 por play extra</span>
        </li>
      </ul>
      <ul class="list-unstyled my-1">
        <li>
          <span
            v-if="userData.currentPlan === 'PRO Booster'"
            class="align-middle"
            style="font-size: 78%;"
          >Ainda restam
            <span style="color: blue;">{{ playRestantes40k }}</span> plays no plano contratado!</span>
          <span
            v-if="userData.currentPlan === 'VSL Booster'"
            class="align-middle"
            style="font-size: 78%;"
          >Ainda restam <span style="color: blue;">{{ playRestantes15k }}</span> plays no plano contratado!</span>
        </li>
      </ul>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BBadge, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      playRestantes40k: 0,
      playRestantes15k: 0,
    }
  },
  mounted() {
    this.subtração()
  },
  methods: {
    subtração() {
      const restamPlay40k = 40000 - this.userData.qtde_play
      const restamPlay15k = 15000 - this.userData.qtde_play
      this.playRestantes40k = restamPlay40k.toLocaleString('pt-BR', { minimumFractionDigits: 0 })
      this.playRestantes15k = restamPlay15k.toLocaleString('pt-BR', { minimumFractionDigits: 0 })
    },
  },

}
</script>

<style>

</style>
